import { render } from "./shot_history.vue?vue&type=template&id=2c02a4ba&scoped=true"
import script from "./shot_history.vue?vue&type=script&lang=js"
export * from "./shot_history.vue?vue&type=script&lang=js"

import "./shot_history.vue?vue&type=style&index=0&id=2c02a4ba&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c02a4ba"]])

export default __exports__